import { routerNames } from "../appCommon.constants";
import { userTypes } from "../MyAccount/myaccount.constants";

export const authenticateAndNavigateMethods = {
    conciergeCallback: 'handleConciergeNavigation',
    lmsCallback: 'handleLmsNavigation',
    chapterManagementCallback: 'handleChapterManagementNavigation',
    m2mxProfileCallback: 'handleM2mxProfileNavigation',
};

export const authenticateAndNavigateConstant = {
    navigateOptions: [
        {
            routeName: routerNames.CONCIERGE_PAGE,
            preCheckMethod: authenticateAndNavigateMethods.conciergeCallback,
        },
        {
            routeName: routerNames.LMS_PAGE,
            preCheckMethod: authenticateAndNavigateMethods.lmsCallback,
        },
        {
            routeName: routerNames.CHAPTER_MANAGEMENT,
            preCheckMethod: authenticateAndNavigateMethods.chapterManagementCallback,
        },
        {
            routeName: routerNames.M2MX_PROFILE,
            preCheckMethod: authenticateAndNavigateMethods.m2mxProfileCallback,
        },
    ],
    navigationUrls: {
        concierge: process.env.VUE_APP_YPO_SF_ASSISTANCE_URL,
        lms: process.env.VUE_APP_LMS_URL,
        chapterManagement: process.env.VUE_APP_CHAPTER_MANAGEMENT_URL,
        m2mxProfile: process.env.VUE_APP_M2MX_PROFILE_URL,
    },
    rolesWithAccessToM2mxProfile: [userTypes.MEMBER, userTypes.SPOUSE_PARTNER],
};
